import React from 'react';

import imgQueda from '../assets/prob-queda.jpg';
import imgCoceira from '../assets/prob-coceira.jpg';
import imgEnergia from '../assets/prob-energia.jpg';
import imgDigestao from '../assets/prob-digestao.jpg';
import imgImunidade from '../assets/prob-imunidade.jpg';
import imgSenior from '../assets/prob-senior.jpg';

const Problemas = () => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const dores = [
    {
      sub: "Queda de pelos por toda a casa",
      icon: "🧹", 
      imgPlaceholder: imgQueda 
    },
    {
      sub: "Coceiras e alergia sem explicação",
      icon: "🐾", 
      imgPlaceholder: imgCoceira
    },
    {
      sub: "Falta de energia e pouco interesse em brincar",
      icon: "🔋", 
      imgPlaceholder: imgEnergia
    },
    {
      sub: "Problemas digestivos frequentes",
      icon: "💩", 
      imgPlaceholder: imgDigestao
    },
    {
      sub: "Imunidade baixa e doenças recorrentes",
      icon: "🛡️", 
      imgPlaceholder: imgImunidade
    },
    {
      sub: "Envelhecimento precoce e dores articulares",
      icon: "🦴", 
      imgPlaceholder: imgSenior
    }
  ];

  return (
    <section style={{padding: '40px 20px', backgroundColor: '#f5f5f7', textAlign: 'center'}}>
      <div className="container" style={{maxWidth: '1250px', margin: '0 auto'}}>
        
        <h2 style={{color: '#FF8C00', fontSize: '2.5rem', fontWeight: '900', marginBottom: '15px', letterSpacing: '-1px'}}>
          Longevidade começa com cuidado diário.
        </h2>
        <p style={{fontSize: '1.1rem', color: '#666', marginBottom: '30px', maxWidth: '700px', margin: '0 auto 60px'}}>
          Você faz tudo por ele... Mas ainda sente que seu pet não esta 100%?
        </p>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))', 
          gap: '15px', 
          justifyContent: 'center'
        }}>
          {dores.map((item, index) => (
            <div key={index} className="modern-card" style={styles.cardContainer}>
              
              <div style={{overflow: 'hidden', height: '65%'}}> 
                 <img 
                   src={item.imgPlaceholder} 
                   alt={item.titulo}
                   className="card-image-zoom" 
                   style={styles.cardImage}
                 />
              </div>
              
              <div style={styles.glassOverlay}>
                <div style={styles.iconCircle}>
                  {item.icon}
                </div>
                <div style={{textAlign: 'center', width: '100%'}}>
                  <h3 style={{margin: 0, color: '#5D2E8C', fontWeight: '800', fontSize: '0.9rem'}}>
                    {item.titulo}
                  </h3>
                  <p style={{margin: '2px 0 0 0', color: '#555', fontSize: '0.7rem', fontWeight: '600', lineHeight: '1.2', textWrap: 'balance'}}>
                    {item.sub}
                  </p>
                </div>
              </div>

            </div>
          ))}
        </div>

        {/* ALERTA FINAL */}
        <div style={styles.alertaBox}>
            <p style={{margin: 0, fontWeight: 'bold', color: '#fff', fontSize: '1rem'}}>
              ⚠️ A verdade? Apenas a alimentação não é suficiente.
            </p>
            <p style={{margin: 0, fontWeight: 'bold', color: '#fff', fontSize: '1rem'}}>
              Seu cão precisa de suporte nutricional completo, gostoso e fácil de oferecer.
            </p>
        </div>
            
        {/* --- BOTÃO DE COMPRA AGORA --- */}
        <div style={{marginTop: '30px'}}>
          <button onClick={() => scrollToSection('ofertas')} style={styles.ctaButtonGreenPop}>
            COMPRAR AGORA ➔
          </button>
        </div>

      </div>
    </section>
  );
};


const styles = {
  cardContainer: {
    position: 'relative',
    height: '250px', 
    borderRadius: '15px',
    overflow: 'hidden',
    boxShadow: '0 20px 40px rgba(0,0,0,0.1)', 
    cursor: 'pointer',
    transition: 'transform 0.3s ease'
  },
  cardImage: {
    width: '100%', 
    height: '100%', 
    objectFit: 'cover',
    transition: 'transform 0.5s ease' 
  },
  glassOverlay: {
    position: 'absolute',
    bottom: '10px', 
    left: '10px',
    right: '10px', 
    width: 'auto', 
    borderRadius: '12px', 
    backgroundColor: 'rgba(255, 255, 255, 0.9)', 
    backdropFilter: 'blur(12px)', 
    WebkitBackdropFilter: 'blur(12px)', 
    padding: '10px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '5px',
    boxShadow: '0 5px 15px rgba(0,0,0,0.1)'
  },
  iconCircle: {
    backgroundColor: '#FF8C00', 
    width: '30px',
    height: '30px',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '1rem',
    flexShrink: 0,
    marginBottom: '5px'
  },
  alertaBox: {
    marginTop: '60px', 
    backgroundColor: '#FF8C00',
    padding: '20px 40px',
    borderRadius: '50px',
    display: 'inline-block',
    boxShadow: '0 15px 30px rgba(255, 140, 0, 0.25)',
    transform: 'rotate(-1deg)' 
  },
  ctaButtonGreenPop: {
    backgroundColor: '#32CD32', // Verde
    color: '#fff',
    border: 'none',
    padding: '18px 40px',
    borderRadius: '10px',
    fontSize: '1rem',
    fontWeight: '900',
    cursor: 'pointer',
    fontFamily: '"Montserrat", sans-serif',
    boxShadow: '0 5px 0px #228B22', // Sombra sólida
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    width: '100%',
    maxWidth: '350px',
    transition: 'all 0.1s ease',
  }
};

export default Problemas;